import type { SitePageLink } from '@testpio/shared';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { http } from '../../../lib/api';

/** The list the Worker embeds in website HTML (worker/html.ts), so the app needs no request. */
function embeddedPages(): SitePageLink[] | null {
  if (typeof document === 'undefined') return null;
  const el = document.getElementById('ur-site-pages');
  if (!el?.textContent) return null;
  try {
    return JSON.parse(el.textContent) as SitePageLink[];
  } catch {
    return null;
  }
}

/** Published website pages for the footer (privacy, terms and pages added in the platform console). */
export function useSitePages(): SitePageLink[] {
  const [embedded] = useState(embeddedPages);
  const fetched = useQuery({
    queryKey: ['site-pages'],
    queryFn: async () => (await http.get<{ pages: SitePageLink[] }>('/public/pages')).pages,
    enabled: embedded === null,
    staleTime: 5 * 60_000,
  });
  return embedded ?? fetched.data ?? [];
}
